<template>
    <div class="package_wrapper">
        <div :class="'item_wrapper item_wrapper_' + type + ' ' + (item.checked[type] ? 'item_wrapper_border' : '')"
            v-for="(item, index) in list" v-if=" type != 'point' || (type=='point' && item.old_point>0)"
  :key="type + item.id + index" @click="check(item)" :title="item.name">
            <div class="coupon_selected" v-if="item.checked[type]"></div>
            <img :src="item.image" width="70" height="70" class="gift_image" />
            <div class="gift_box">
                <div class="gift_name">{{ item.name }}</div>
                <a-row>
                    <a-col :span="9">
                        <div class="gift_weight">{{ item.weight }}kg</div>
                    </a-col>
                    <a-col :span="15">
                        <div class="gift_price">{{ type == 'point' ? item.point + '积分' : '￥' + item.price }}</div>
                    </a-col>
                </a-row>
                <div class="input_num" v-if="type == 'money'">
                    <input-number :num="item.num" :max="max" tip="积分礼品包装每种限购一个" onlyTip style="width:100%"
                        @changeCartNum="changeNum($event, item)" :CheckType="item.checked[type]" />
                </div>
            </div>
            <br class="clear" />
        </div>
    </div>
</template>

<script>
import InputNumber from '@/components/common/InputNumber2'

export default {
    name: 'PackageGiftBox',
    components: { InputNumber },
    props: ["type", "list"],
    data() {
        return {
            ids: []
        }
    },
    watch: {
        list: {
            handler(val) {
                var ids = [];

                for (var i = 0; i < val.length; i++) {
                    if (val[i].checked) {
                        ids.push(val[i].id);
                    }
                }

                this.ids = ids;
            },
            deep: true
        },
    },
    computed: {
        max() {
            return this.type === 'point' ? 1 : undefined
        }
    },
    methods: {
        changeNum(num, item) {
            item.checked[this.type] = num > 0

            this.$emit('check', {
                id: item.id,
                num: num,
                type: this.type,
                gift_type: this.giftType,
                checked: item.checked[this.type]
            });
        },
        check(item) {
            this.$emit('check', {
                id: item.id,
                num: item.num,
                type: this.type,
                checked: !item.checked[this.type]
            });
        },
    }
}
</script>

<style scoped>
.gift_price {
    color: #fd5902;
    font-size: 12px;
    line-height: 30px;
    text-align: right;
}

.gift_weight {
    color: #666;
    font-size: 12px;
    line-height: 30px;
}

.gift_name {
    line-height: 20px;
    font-size: 13px;
    font-family: "microsoft yahei";
    color: #333;
    height: 40px;
    overflow: hidden;
}

.gift_box {
    float: right;
    width: 140px;
}

.gift_image {
    float: left;
    margin-right: 5px;
}

.input_num {
    text-align: center;
    width: 110px;
    overflow: hidden;
    height: 30px;
    position: absolute;
    right: 2px;
    bottom: 2px;
}

.item_wrapper {
    width: 230px;
    border: 1px solid #f4f4f4;
    margin-top: 10px;
    margin-right: 10px;
    position: relative;
    cursor: pointer;
    padding: 5px;
}

.item_wrapper_point {
    height: 83px;
}

.item_wrapper_money {
    height: 110px;
}

.item_wrapper_border {
    border: 1px solid #fd5902;
}

.coupon_selected {
    position: absolute;
    top: 0;
    right: -1px;
    z-index: 10;
    width: 27px;
    height: 27px;
    background: url('~@/assets/images/deal-manage/coupon_selected.png') no-repeat center center;
    background-size: 100% 100%;
}

.item_wrapper:hover {
    border-color: #fd5902;
}

.package_img_wrapper {
    padding: 6px;
}

.name {
    max-width: 140px;
    font-size: 13px;
    color: #666666;
}

.price {
    margin: 5px;
}

.checkbox {
    position: absolute;
    top: 5px;
    right: 6px;
}

.mt5 {
    margin-top: 5px;
}

.package_wrapper {
    display: flex;
    flex-wrap: wrap;
    max-height: 480px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/order/PackageGiftBox.vue